import {Lead, Slot, Text, Trail} from '@logistics-frontend/blocks'
import React, {memo} from 'react'

import * as classes from './AddressPoint.classes'

type AddressPointProps = {
  children?: React.ReactNode
  lead?: React.ReactNode
  onClick?: VoidFunction
  trail?: React.ReactNode
}

export const AddressPoint = memo(
  ({children, lead, onClick, trail}: AddressPointProps): React.ReactElement => (
    <Slot className={classes.addressPointSlot} Component="button" onClick={onClick} size="l">
      {lead && <Lead>{lead}</Lead>}
      <Text>{children}</Text>
      {trail && <Trail>{trail}</Trail>}
    </Slot>
  ),
)
